<template>
  <app-side-menu>
    <aside
      class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          Filters
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <input
                class="input is-capitalized"
                type="text"
                placeholder="Item No."
                v-model="value.itemNo"
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input
                class="input is-capitalized"
                type="text"
                placeholder="Description"
                v-model="value.itemDesc"
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="value.type">
                  <option
                    value=""
                    selected>-- Type --</option>
                  <option :value="itemTypeEnum.LABOUR">Labour</option>
                  <option :value="itemTypeEnum.PARTS">Parts</option>
                  <option :value="itemTypeEnum.OPG">OPG</option>
                  <option :value="itemTypeEnum.MISC">Misc</option>
                  <option :value="itemTypeEnum.SUBL">Sublet</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="value.status">
                  <option
                    value="2"
                    selected>-- Status --</option>
                  <option :value="1">Standard</option>
                  <option :value="0">Custom</option>
                </select>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <hr>
      <div class="field is-grouped is-pulled-right">
        <div class="control">
          <button
            class="button is-primary"
            @click="onFilterClick">
            <span class="icon">
              <i class="mdi mdi-magnify mdi-18px" />
            </span>
            <span>Filter</span>
          </button>
        </div>
        <div class="control">
          <button
            class="button"
            @click="onResetClick">
            <span class="icon">
              <i class="mdi mdi-refresh mdi-18px" />
            </span>
            <span>Reset</span>
          </button>
        </div>
      </div>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
// import { BulmaRadioButton } from '@/components/BulmaRadio'
import { ItemTypes } from '@/enums'

export default {
  name: 'ItemListSideMenu',
  inject: ['$vv'],
  components: {
    AppSideMenu
    // BulmaRadioButton
  },
  props: {
    filter: null,
    value: null
  },
  data() {
    return {
      selectedActive: 1
    }
  },
  computed: {
    $v() {
      return this.$vv || this.$v
    },
    itemTypeEnum: function() {
      return ItemTypes
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    const elements = document.getElementsByClassName('datepicker')
    Array.from(elements).forEach((element, index, array) => {
      const parent = element.parentNode
      if (parent.nodeName === 'BODY') {
        parent.removeChild(element)
      }
    })
  },
  methods: {
    onFilterClick() {
      this.$emit('filter')
    },
    onResetClick() {
      this.$emit('reset')
    }
  }
}
</script>
<style lang="scss" scoped>
@use '@/assets/style/mixins/inputs/placeholder' as *;;
input.uppercase {
  text-transform: uppercase;
  @include reset-placeholder-text-transform;
}
</style>
